module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lemons@2x_35aaf1.jpg";